/* eslint-disable class-methods-use-this */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Col, Grid, Row} from 'react-bootstrap';
import PageTitle from '../../../common/page-title/index';
import StaffRewardSettingsForm from './staff-reward-settings-form';

import './styles.css';
import t from '../../../../data/translations';

class StaffRewardSettings extends Component {
  render() {
    return (
      <Grid bsClass="container" fluid className="staff-reward-settings">
        <Row>
          <Col lg={12}>
            <PageTitle>
              { t('staffRewardSettings') }
            </PageTitle>
            <StaffRewardSettingsForm/>
          </Col>
        </Row>
      </Grid>
    );
  }
}

const mapStateToProps = state => ({
  fetched: state.brands.fetched,
  fetching: state.brands.fetching,
});

export default connect(mapStateToProps)(StaffRewardSettings);



// WEBPACK FOOTER //
// ./src/components/admin/staff-reward/settings/index.jsx